import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AuthWrapper2/hooks/useCurrentUserAnPCheck.ts
function useCurrentUserAnPCheck(check) {
	const user = useSingleton(AuthViewModel).state.identityInfo.user;
	return user.superAdmin || check(user);
}
export { useCurrentUserAnPCheck };

//# sourceMappingURL=useCurrentUserAnPCheck.js.map